import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import NewsCard from 'fragments/NewsCard';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $currentPage: PositiveInt!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on NewsIndex {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          title
          newsTitle
          newsSubtitle
          breadcrumbs {
            title
            url
          }
          newsArticles(page: $currentPage, perPage: 6) {
            items {
              ...NewsCard
            }
            pagination {
              total
              count
              prevPage
              nextPage
              totalPages
              currentPage
            }
          }
        }
      }
    }
  `,
  { NewsCard, Logo },
);
